import Card from "components/card";
import InputField from "components/fields/InputField";
import Centered from "layouts/auth/types/Centered";
import React, {useState} from "react";
import FixedPlugin from "../../components/fixedPlugin/FixedPlugin";
import {Link, useNavigate} from "react-router-dom";
import {useUserAuth} from "../../context/UserAuthContext";
import axios from "axios";
import {AES} from "crypto-js";

function SignInWithOtp() {
    const navigate = useNavigate();

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    let [email, setEmail] = useState("");
    const {
        logIn,
        userToken,
        userstate,
        user,
        accesscontrollevel,
        getEmailOtp,
        getMobileOtp,
        verifyEmailOtp,
        verifyMobileOtp,
        resetPassword,
        checkPasswords,
        isValidEmailAddress,
        isValidMobileNumber
    } = useUserAuth();
    const [errorMessage, setErrorMessage] = useState("");

    function checkEmailExists(email) {
        var bodyFormData;
        bodyFormData = {
            email: email,
            action: 2
        }
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkEmail',
            data: bodyFormData
        }).then(async response => {
            //console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", email)

                    let otpResponse = await getEmailOtp(email)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        sessionStorage.setItem("pageFrom", "LOTP")
                        navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }


        })
            .catch(
                error => {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            )
    }

    function checkMobileExists(mobileNumber) {
        var bodyFormData;
        bodyFormData = {
            mobile: mobileNumber,
            action: 2
        }
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkMobile',
            data: bodyFormData
        }).then(async response => {
            //console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", mobileNumber)

                    let otpResponse = await getMobileOtp(mobileNumber)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        sessionStorage.setItem("pageFrom", "LOTP")
                        navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }

        })
            .catch(
                error => {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            )
    }

    const navigateToOtpScreen = async (e) => {
        e.preventDefault()

        //setEmail(document.getElementById('email').value)
        email = document.getElementById('email').value

        //console.log(email)

        if (email.includes("@")) {
            if (isValidEmailAddress(email)) {
                checkEmailExists(email)
                //console.log("email: ", email + "is valid")
            } else {
                setErrorMessage("The email " + email + "  address is not as per format!!!")

            }
        } else {
            if (isValidMobileNumber(email)) {
                setErrorMessage("")
                checkMobileExists(email)
                //console.log("mobile: ", email + "is valid")
            } else {
                setErrorMessage("The mobile number " + email + " is not as per format!!!")

            }
        }
    }

    return (
        <Centered
            maincard={
                <Card
                    extra={
                        "max-w-[405px] md:max-w-[550px] h-max mt-32 md:mt-[120px] mx-2.5 md:mx-auto mb-auto pb-2.5 pt-8 md:pt-2.5 px-4 md:!p-[50px]"}>
                    <FixedPlugin/>
                    <p className="mb-2 text-4xl font-bold text-navy-700 dark:text-white">
                        Login with an OTP
                    </p>
                    <p className="mt-[10px] ml-1 mb-8 text-base text-gray-600">
                        Just let us know your email address or mobile number and we'll send you
                        a OTP that will allow you to login directly.
                    </p>
                    {/* Email */}
                    <InputField
                        variant="auth"
                        label="Email or Mobile Number*"
                        placeholder="Email Address or Mobile Number"
                        id="email"
                        type="text"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />

                    {/* button */}
                    <button className="mt-4 w-full rounded-xl bg-[#004c86] py-3 text-base font-medium text-white transition duration-200 hover:bg-[#004c86]
          active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86]"
                            onClick={navigateToOtpScreen}>
                        Get OTP
                    </button>

                    <div className="mt-3">
            <span className="text-sm font-medium text-navy-700 dark:text-gray-500">

            </span>
                        {/*<a
                            href="/auth/sign-in"
                            className="ml-1 text-sm font-medium text-[#004c86] hover:text-[#004c86] dark:text-white"
                        >
                            Return to login page
                        </a>*/}

                        <Link to={"/auth/sign-in"}  className="ml-1 text-sm font-medium text-[#004c86] hover:text-[#004c86] dark:text-white">
                            Return to login page
                        </Link>
                    </div>

                    <span className="errorMessage">
                        {errorMessage}
                    </span>
                </Card>
            }
        />
    );
}

export default SignInWithOtp;
